export default __webpack_public_path__ + "static/media/mode-513.706599a3.svg";